import { css } from '@wrisk/styled-system'
import styled from 'styled-components'

interface GhostSelectProps {
  loading?: boolean
  backgroundUrl?: string
}

export const GhostSelect = styled.select.attrs<GhostSelectProps>((props) => ({
  ...props,
  disabled: props.disabled || props.loading,
  backgroundUrl: props.loading
    ? props.theme.icons.loadingDark.url
    : props.theme.icons.chevronDown.url,
}))(
  css({
    py: 5,
  }),

  (props) => ({
    border: 'none',
    appearance: 'none',
    '-webkit-appearance': 'none',
    cursor: 'pointer',
    width: '100%',

    background: `url(${props.backgroundUrl}) no-repeat right center`,
    backgroundSize: '16px',

    '&:focus': {
      outline: '0',
    },
  }),
  (props) =>
    props.disabled
      ? {
          color: 'textDisabled',
          cursor: 'not-allowed',
        }
      : {},
)
